const ShippingRestrictionScope = {
  ALL: "all",
  SPECIFIC: "specific",
} as const;

type ShippingRestrictionScope =
  typeof ShippingRestrictionScope[keyof typeof ShippingRestrictionScope];

export default ShippingRestrictionScope;
